import { IApplicationState } from '../../types/redux';

export const selectAvailableFilters = (state: IApplicationState) => state.marketTrand.filters;
